// @ts-check
import {
  Flex,
  SkeletonText,
  TabbedMenu,
  TabbedMenuItem,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '~/design-system';

export default function ChangesPreviewTableSkeleton({ ...rest }) {
  return (
    <Flex sx={{ flexDirection: 'column', padding: '0px 15% 30px 15%' }}>
      <ChangesTabbedMenuSkeleton />
      <Table sx={{ width: '100%' }}>
        <DefaultTableHeaderSkeleton />
        <TableBody>
          <DefaultTableRowSkeleton />
          <DefaultTableRowSkeleton />
          <DefaultTableRowSkeleton />
        </TableBody>
      </Table>
    </Flex>
  );
}

function ChangesTabbedMenuSkeleton() {
  return (
    <TabbedMenu sx={{ margin: 0 }}>
      <TabbedMenuItem>
        <SkeletonText width={100} />
      </TabbedMenuItem>
      <TabbedMenuItem>
        <SkeletonText width={100} />
      </TabbedMenuItem>
      <TabbedMenuItem>
        <SkeletonText width={100} />
      </TabbedMenuItem>
    </TabbedMenu>
  );
}

function DefaultTableHeaderSkeleton() {
  return (
    <TableHead>
      <TableRow>
        <TableHeader sx={{ backgroundColor: 'brand.lightGray', width: 100 }}>
          <SkeletonText width={100} />
        </TableHeader>

        <TableHeader sx={{ backgroundColor: 'brand.lightGray', width: 250 }}>
          <SkeletonText width={100} />
        </TableHeader>
        <TableHeader sx={{ backgroundColor: 'brand.lightGray', width: 250 }}>
          <SkeletonText width={100} />
        </TableHeader>
        <TableHeader sx={{ backgroundColor: 'brand.lightGray', width: 250 }}>
          <SkeletonText width={100} />
        </TableHeader>
      </TableRow>
    </TableHead>
  );
}

function DefaultTableRowSkeleton() {
  return (
    <TableRow>
      <TableCell
        sx={{
          height: 65,
          width: 260,
        }}
      >
        <SkeletonText />
      </TableCell>
      <TableCell sx={{ height: 65 }}>
        <SkeletonText />
      </TableCell>
      <TableCell sx={{ height: 65 }}>
        <SkeletonText />
      </TableCell>
      <TableCell sx={{ height: 65 }}>
        <SkeletonText />
      </TableCell>
    </TableRow>
  );
}
